import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  fill: "none",
  "stroke-width": "6",
  "stroke-linecap": "round",
  cx: "33",
  cy: "33",
  r: "30"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({
				'text-primary': _ctx.variant === 'primary',
				'text-gray-800': _ctx.variant === 'dark',
				'text-gray-400': _ctx.variant === 'gray',
			})
    }, [
      (_openBlock(), _createElementBlock("svg", {
        class: "spinner",
        width: _ctx.spinnerSize,
        height: _ctx.spinnerSize,
        style: _normalizeStyle(_ctx.size === 'xl' ? 'filter: drop-shadow(1px 1px 2px rgba(0,0,0,0.1))' : ''),
        viewBox: "0 0 66 66",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_4, 12, _hoisted_2))
    ], 2)
  ]))
}